import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="join-form"
// This controller is for the full join form (new users)
export default class extends Controller {
  static targets = ["codeStatus", "codeValid", "codeInvalid", "className", "classNameText", "newUserFields"]
  
  connect() {
    // Initialize form state
    this.toggleNewUserFields(true)
  }

  async checkCode(event) {
    const code = event.target.value.trim()
    
    if (code.length < 3) {
      this.hideCodeStatus()
      this.hideClassName()
      return
    }
    
    try {
      const response = await fetch(`/check_join_code?code=${encodeURIComponent(code)}`, {
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      })
      
      const data = await response.json()
      
      if (data.valid) {
        this.showValidCode()
        this.showClassName(data.class_name)
      } else {
        this.showInvalidCode()
        this.hideClassName()
      }
    } catch (error) {
      console.error("Error checking code:", error)
      this.hideCodeStatus()
      this.hideClassName()
    }
  }
  
  async checkExistingUser(event) {
    const email = event.target.value.trim()
    
    if (!this.isValidEmail(email)) {
      this.toggleNewUserFields(true)
      return
    }
    
    try {
      const response = await fetch(`/check_existing_user?email=${encodeURIComponent(email)}`, {
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      })
      
      const data = await response.json()
      this.toggleNewUserFields(!data.exists)
    } catch (error) {
      console.error("Error checking user:", error)
      this.toggleNewUserFields(true)
    }
  }
  
  showValidCode() {
    this.codeStatusTarget.classList.remove("hidden")
    this.codeValidTarget.classList.remove("hidden")
    this.codeInvalidTarget.classList.add("hidden")
  }
  
  showInvalidCode() {
    this.codeStatusTarget.classList.remove("hidden")
    this.codeValidTarget.classList.add("hidden")
    this.codeInvalidTarget.classList.remove("hidden")
  }
  
  hideCodeStatus() {
    this.codeStatusTarget.classList.add("hidden")
    this.codeValidTarget.classList.add("hidden")
    this.codeInvalidTarget.classList.add("hidden")
  }
  
  showClassName(className) {
    this.classNameTarget.classList.remove("hidden")
    this.classNameTextTarget.textContent = className
  }
  
  hideClassName() {
    this.classNameTarget.classList.add("hidden")
    this.classNameTextTarget.textContent = ""
  }
  
  toggleNewUserFields(show) {
    if (show) {
      this.newUserFieldsTarget.classList.remove("hidden")
    } else {
      this.newUserFieldsTarget.classList.add("hidden")
    }
  }
  
  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }
}